import script from "./colorcardReceiver.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardReceiver.vue?vue&type=script&setup=true&lang=js"

import "./colorcardReceiver.vue?vue&type=style&index=0&id=06e1a7ab&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e1a7ab"]])

export default __exports__